import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { BillingFrequency } from '@delmonicos/shared-sdk/libs/cpms/src/libs/shared/src/enums/billing-frequency.enum';
import { useTranslation } from 'react-i18next';

export interface EmspBoEmspUserBillingFrequencyFilterStateControllerProps {
  value: BillingFrequency;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoEmspUserBillingFrequencyFilterStateController = ({
  value,
  onRemove,
}: EmspBoEmspUserBillingFrequencyFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ///////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="calendar"
      label={t(`delmonicos-shared-sdk.billing-frequency.${value}`)}
      onRemove={onRemove}
    />
  );
};
